module.exports = __webpack_public_path__ + "img/wf.082d2ad5.svg";